var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2098_765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16C8.2928 16 8.09409 15.9177 7.94757 15.7712C7.80106 15.6247 7.71875 15.426 7.71875 15.2188V0.78125C7.71875 0.57405 7.80106 0.375336 7.94757 0.228823C8.09409 0.08231 8.2928 0 8.5 0C8.7072 0 8.90591 0.08231 9.05243 0.228823C9.19894 0.375336 9.28125 0.57405 9.28125 0.78125V15.2188C9.28125 15.426 9.19894 15.6247 9.05243 15.7712C8.90591 15.9177 8.7072 16 8.5 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7188 8.78125H1.28125C1.07405 8.78125 0.875336 8.69894 0.728823 8.55243C0.58231 8.40591 0.5 8.2072 0.5 8C0.5 7.7928 0.58231 7.59409 0.728823 7.44757C0.875336 7.30106 1.07405 7.21875 1.28125 7.21875H15.7188C15.926 7.21875 16.1247 7.30106 16.2712 7.44757C16.4177 7.59409 16.5 7.7928 16.5 8C16.5 8.2072 16.4177 8.40591 16.2712 8.55243C16.1247 8.69894 15.926 8.78125 15.7188 8.78125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2098_765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconBlack);
export default __webpack_public_path__ + "static/media/plusIconBlack.9edddd01fdca06cb32e76238d8f9caf2.svg";
export { ForwardRef as ReactComponent };